import axios from 'axios';
import {PageVO} from "@/declares/vo/PageVO";
import {PayRecordSearchDTO} from "@/declares/dto/payCenter/PayRecordSearchDTO";
import {PayRecordSearchVO} from "@/declares/vo/payCenter/PayRecordSearchVO";
import {NotifyBizRecordDO} from "@/declares/entity/payCenter/NotifyBizRecordDO";


export const notifyBizRecordApi = {

  async findByFlowNo(flowNo: string): Promise<PageVO<NotifyBizRecordDO>> {
    return axios.post(`/admin/peony/notifyBizRecord/findByFlowNo`, {flowNo});
  }
};
